import styled from '@emotion/styled';
import { r, tabletUp } from '../../../shared/lib/responsive';
import { PromoCtaWrap } from '../../../shared/ui/promo-cta';

export const Screen = styled.div`
  position: relative;
  width: 100%;
  max-width: var(--screen-max-width);
  ${r('height', 812)}
  margin: 0 auto;
  overflow: hidden;
  background: var(--color-bg-base);

  ${tabletUp} {
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.15);
  }
`;

export const Foreground = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
`;

export const Restaurant = styled.section`
  position: absolute;
  top: 19.5%;
  left: 50%;
  transform: translateX(-50%);
  ${r('width', 69)}
`;

export const Carousel = styled.section`
  position: absolute;
  top: 33%;
  left: 0;
  width: 100%;
`;

export const Footer = styled.footer`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
`;

export const RewardNotice = styled.p`
  position: absolute;
  ${r('top', 676)}
  left: 0;
  right: 0;
  margin: 0;
  text-align: center;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-reward-notice-size);
  line-height: 1.4;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
  pointer-events: none;
`;

export const CtaWrap = PromoCtaWrap;
